import React from 'react';
import SEO from '../components/SEO';
import MantraSection from '../components/MantraSection';
import WhatIsKompaSection from '../components/WhatIsKompaSection';

const ComoFunciona = ({ scrollToSection }) => {
  return (
    <>
      <SEO pathname="/como-funciona" />
      <div className="pt-20">
        <MantraSection scrollToSection={scrollToSection} />
        <WhatIsKompaSection />
      </div>
    </>
  );
};

export default ComoFunciona;
